import React from "react";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { tokens } from "../theme";

const NavHeading = styled(Box)({
  lineHeight: 1.6,
  // The row is a single line that scrolls. Without nowrap the last labels broke
  // across two lines and the row still overran its container, so "Work History"
  // and "Self Identification" were clipped rather than reachable.
  whiteSpace: "nowrap",
  flexShrink: 0,
});

const StyledLink = styled(Link)({
  color: "inherit",
  textDecoration: "none",
});

/**
 * The record's tab row.
 *
 * An employee record has thirteen tabs and a container that cannot always hold
 * them, so the row scrolls horizontally rather than wrapping. The scrollbar
 * itself is hidden: it would sit directly on the 1px bottom border and read as
 * a broken rule.
 */
const TopNavbar = ({ navItems, active }) => {
  return (
    <Box
      component="nav"
      sx={{
        width: "100%",
        display: "flex",
        gap: "1.25rem",
        borderBottom: `1px solid ${tokens.border}`,
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {navItems.map((item) => {
        const isActive = active === item.check;
        return (
          <NavHeading
            key={item.check}
            aria-current={isActive ? "page" : undefined}
            sx={{
              color: isActive ? tokens.primary : tokens.text,
              borderBottom: isActive ? `2px solid ${tokens.primary}` : "2px solid transparent",
              fontWeight: isActive ? 500 : 400,
            }}
          >
            <StyledLink to={item.link}>{item.value}</StyledLink>
          </NavHeading>
        );
      })}
    </Box>
  );
};

export default TopNavbar;
